import { render, staticRenderFns } from "./NoteTextEditor.vue?vue&type=template&id=50a097c9&"
import script from "./NoteTextEditor.vue?vue&type=script&lang=js&"
export * from "./NoteTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./NoteTextEditor.vue?vue&type=style&index=0&id=50a097c9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports